<script lang="ts">
  import { defineComponent } from 'vue';
  import { useRegisterSW } from 'virtual:pwa-register/vue';

  export default defineComponent({
    name: 'UpdateNotification',
    setup() {
      const { needRefresh, updateServiceWorker } = useRegisterSW();

      function update(): void {
        updateServiceWorker();
      }

      function dismiss(): void {
        needRefresh.value = false;
      }

      return {
        needRefresh,
        update,
        dismiss,
      };
    },
  });
</script>
<template>
  <v-snackbar v-model="needRefresh" :timeout="-1" min-height="68">
    A new version is available.
    <template v-slot:actions>
      <v-btn variant="text" @click="dismiss"> Dismiss </v-btn>
      <v-btn variant="text" @click="update"> Update </v-btn>
    </template>
  </v-snackbar>
</template>
